var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoDemoSymbolExercises(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        mix-blend-mode: overlay;\n        opacity: .36;\n      }\n\n      .cls-6 {\n        fill: #124c72;\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -2416,
    y: 194.5,
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -147,
    y: 194.5,
    width: 1920,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Exercise_1.1",
    "data-name": "Exercise 1.1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background-2",
    "data-name": "Background"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.91,21.82l-2.59-1.54L-1.14,1.22c-.57-1.38-.97-2.59-1.3-3.73l-6.97,12-2.51-1.46L-3.01-7.37-.49-5.91,7.53,14.85l.81,2.19,7.95-13.78,2.51,1.46-9.89,17.11Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "webcam-video-circle--work-video-meeting-camera-company-conference-office"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    className: "cls-6",
    d: "M.5,17.75C.5,8.22,8.22.5,17.75.5s17.25,7.72,17.25,17.25-7.72,17.25-17.25,17.25S.5,27.28.5,17.75ZM21.73,15.1l3.74-1.66c.1-.04.21-.05.32-.04s.21.05.3.11c.09.06.16.14.21.24.05.1.08.2.07.31v7.38c0,.11-.02.21-.07.31-.05.1-.12.18-.21.24-.09.06-.19.1-.3.11-.11.01-.22,0-.32-.04l-3.74-1.66v1.99c0,.35-.14.69-.39.94-.25.25-.59.39-.94.39h-9.96c-.35,0-.69-.14-.94-.39-.25-.25-.39-.59-.39-.94v-9.29c0-.35.14-.69.39-.94.25-.25.59-.39.94-.39h9.96c.35,0,.69.14.94.39.25.25.39.59.39.94v1.99Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDemoSymbolExercises);
export default __webpack_public_path__ + "static/media/Video-Demo-Symbol_Exercises.05b6fa722b15b4cbe3cd5e2c779c9caf.svg";
export { ForwardRef as ReactComponent };